"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _label = _interopRequireDefault(require("../label/label"));

require("./toggleButton.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ToggleButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ToggleButton, _React$Component);

  var _super = _createSuper(ToggleButton);

  function ToggleButton() {
    var _context;

    var _this;

    (0, _classCallCheck2["default"])(this, ToggleButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat["default"])(_context = [this]).call(_context, args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClick", function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          isActive = _this$props.isActive,
          name = _this$props.name;

      if (!disabled && (0, _utils.isFunction)(onClick)) {
        onClick.call(null, name, !isActive, event);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(ToggleButton, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          disabled = _this$props2.disabled,
          isActive = _this$props2.isActive,
          label = _this$props2.label,
          isInvalid = _this$props2.isInvalid,
          dataTestId = _this$props2.dataTestId;
      var sliderClass = "oui-toggle-slider ".concat(isActive ? "oui-on" : "oui-off");
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        "data-testid": dataTestId,
        className: (0, _utils.gatherClasses)(this.props, "oui-toggle-button"),
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 32) {
            _this2.onClick(e);
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _utils.gatherClasses)(null, "oui-main-switch", disabled && "oui-disabled"),
        onClick: this.onClick,
        onKeyDown: null,
        tabIndex: "-1",
        role: "button",
        "aria-label": isActive ? "toggle button on" : "toggle button off"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: sliderClass
      }, " ")), label && /*#__PURE__*/_react["default"].createElement(_label["default"], {
        className: (0, _utils.gatherClasses)(null, "oui-switch-label", isInvalid && "oui-is-invalid"),
        text: label
      }));
    }
  }]);
  return ToggleButton;
}(_react["default"].Component);

ToggleButton.defaultProps = {
  name: "",
  isActive: false,
  dataTestId: "orion-toggle-button"
};
ToggleButton.propTypes = {
  isActive: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  label: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  isInvalid: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};
ToggleButton.displayName = "OrionToggleButton";
var _default = ToggleButton;
exports["default"] = _default;